import React from "react";
import { Route, Routes } from "react-router-dom";
import CustomRouter from "./components/CustomRouter";
import history from "./providers/history";
import Authentication from "./views/Authentication";
import { useDispatch, useSelector } from "react-redux";
import Dashboard from "./views/Dashboard";
import Users from "./views/Users";
import ItemObservation from "./views/ItemsObservations";
import ItemName from "./views/ItemsNames";
import "./providers/i18n";
import UserChangePasswordForm from "./views/UserChangePasswordForm";
import { IApplicationState } from "./store";
import ModalContainer from "./components/ModalContentContainer";
import ModalContent from "./components/ModalContent";
import { stopChangePassword } from "./store/authentication/slice";
import PhotoContent from "./components/PhotoContent";
import VideoContent from "./components/VideoContent";
import { IPhotosState } from "./store/photos/types";
import { IVideosState } from "./store/videos/types";

const App: React.FC = () => {
  const authentication = useSelector(
    (state: IApplicationState) => state.authentication
  )
  const photosState = useSelector(
    (state: IApplicationState) => state.photos
  ) as IPhotosState

  const videoState = useSelector(
    (state: IApplicationState) => state.videos
  ) as IVideosState

  const dispatch = useDispatch();

  const photosUrl = photosState.photoViewer

  const videosUrl = videoState.videosViewer

  return (
    <>
      {photosUrl && <PhotoContent photos={photosUrl} />}
      {videosUrl && <VideoContent videos={videosUrl} />}
      <CustomRouter history={history}>
        <Routes >
          <Route path="/*" element={<Dashboard />} />
          <Route path="/users/*" element={<Users />} />
          <Route path="/login" element={<Authentication />} />
          <Route path="/settings/item-observation/*" element={<ItemObservation />} />
          <Route path="/settings/item-name/*" element={<ItemName />} />
        </Routes>
      </CustomRouter>
      {authentication.draftChangePassword && (
        <ModalContainer>
          <ModalContent
            onClose={() => dispatch(stopChangePassword())}>
            <UserChangePasswordForm />
          </ModalContent>
        </ModalContainer>
      )}
    </>
    // <Authentication />
  );
};

export default App;
